// ===================ZIPCODE JS================================================================
var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
var mS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
         
//  sheet link ::: https://docs.google.com/spreadsheets/d/1Hzk3retgd2sCK8N_pqW0GpR7f9752GlXQXraVwCjrFw/edit#gid=0
//  sheet ID -> 139vNJt86FT0U20WcZdxcrx54kJXII05ar7_aJXXYTZ0
var XMLR = new XMLHttpRequest();
XMLR.open("GET","https://sheets.googleapis.com/v4/spreadsheets/1REZSpYFLSE2gTk6f1dbciBG5hfUfphl9C18q26zQYWw/values/Final!A2:C?key=AIzaSyAW3mnVOkwOqtiWMBrzyD7yrd1ctt-E9s8", false);
XMLR.addEventListener('loadend', ()=>{
  console.log('load ended')
  document.querySelector('#zip').innerHTML = `Check`;
  var sheetData = JSON.parse(XMLR.responseText);
  var zipcode = sheetData.values;
  let btn = document.querySelector("#zip");
  if(btn){
  btn.addEventListener("click", function(){
    var zipvalue = document.getElementById('zipinput').value;
    let found = zipcode.find(zip=>zip[0] == zipvalue);
    var now= new Date(); 
    var hou= now.getHours();
      if(found){
        if(hou < 16){
      var exp_date = new Date(new Date().setDate(new Date().getDate() + parseInt(found[1])));
    }
        else{
      var exp_date = new Date(new Date().setDate(new Date().getDate() + 1 + parseInt(found[1]) ));
    }
      exp_date = exp_date.toString();
      var exp_day = exp_date.split(" ")[0]   ;  // days[exp_date.getDay()];
      var exp_date1 = exp_date.split(" ")[2] ; // exp_date.getDate();
      var exp_month = exp_date.split(" ")[1]  ; //mS[exp_date.getMonth()];
      document.getElementById("defualt_message").innerHTML = "";
      if(found[1]){ 
        if(found[2].toLowerCase() == 'true'){
           document.getElementById("meassage").innerHTML = `Yay! Bummy readily delivers to your place, with COD option!<span> Estimated Delivery by ${exp_day} ${exp_month} ${parseInt(exp_date1)}</span>` ;
        }else{
           document.getElementById("meassage").textContent = `Bummy readily delivers to your doorstep! Estimated Delivery by ${exp_day} ${exp_month} ${parseInt(exp_date1)}` ;
        }
      }
      else { document.getElementById("meassage").textContent = `` ;   }
      if(found[2].toLowerCase() == 'true'){document.getElementById("meassage1").textContent =  ``;}
      else if(found[2] == '' || !found[2]){ document.getElementById("meassage1").textContent = '';}
      else { document.getElementById("meassage1").textContent = 'Sorry! COD is not available :( ';}
      }else{
      document.getElementById("defualt_message").innerHTML = 'Oops! Bummy doesn’t know this location.Let’s find a way - Chat with the MomsConnect Team on <a href="https://wa.me/917499025345">WhatsApp<a>';
      document.getElementById("meassage").textContent = `` ;
      document.getElementById("meassage1").textContent = `` ;  
      }
  });
  }
}); 
XMLR.send(null);